import React, { useState } from 'react';
import axiosInstance from '../utils/axiosConfig';

interface LoginProps {
  onLogin: (token: string, refreshToken: string) => void;
}

const Login: React.FC<LoginProps> = ({ onLogin }) => {
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await axiosInstance.post('/api/auth/login', {
        password,
      });

      console.log('✅ Login response:', response.status);
      console.log('✅ Response data:', response.data);
      console.log('✅ Cookie set automatically.');

      onLogin('authenticated', '');
    } catch (err: any) {
      console.error('Login error:', err);
      console.error('Error response:', err.response?.data);
      console.error('Error status:', err.response?.status);
      console.error('Error message:', err.message);
      setError(
        err.response?.data?.error ||
          err.response?.data?.message ||
          err.message ||
          'Network Error'
      );
    }

    setLoading(false);
  };

  return (
    <div className="dusk-admin min-h-screen flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <div
          className="rounded-2xl p-8 backdrop-blur-sm"
          style={{
            background: 'var(--dusk-admin-panel-strong)',
            border: '1px solid var(--dusk-line-strong)',
          }}
        >
          <div className="text-center mb-10">
            <h1
              className="text-3xl font-bold mb-2 m-0 tracking-wide"
              style={{ color: 'var(--dusk-copper)' }}
            >
              DUSKPROOF Admin
            </h1>
            <p className="text-sm m-0" style={{ color: 'var(--dusk-muted)' }}>
              Management System
            </p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label
                htmlFor="password"
                className="block text-sm font-semibold mb-3"
                style={{ color: 'var(--dusk-ink)' }}
              >
                Admin Password
              </label>
              <input
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="dusk-admin-input"
                placeholder="Enter your password"
                required
                autoFocus
              />
            </div>

            {error && (
              <div
                className="px-4 py-3 rounded-xl flex items-start space-x-3"
                style={{
                  background: 'rgba(208, 0, 104, 0.12)',
                  border: '1px solid rgba(208, 0, 104, 0.35)',
                  color: 'var(--dusk-amber)',
                }}
              >
                <svg className="w-5 h-5 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                  <path
                    fillRule="evenodd"
                    d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                    clipRule="evenodd"
                  />
                </svg>
                <span className="text-sm">{error}</span>
              </div>
            )}

            <button type="submit" disabled={loading} className="dusk-admin-btn w-full !py-3">
              {loading && (
                <svg className="w-5 h-5 animate-spin" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 2v20m10-10H2" />
                </svg>
              )}
              <span>{loading ? 'Logging in...' : 'Login'}</span>
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
